import { Phone } from "lucide-react";

const scrollTo = (hash) => (e) => {
  e.preventDefault();
  if (window.__lenis) window.__lenis.scrollTo(hash, { offset: -72 });
  else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};

export default function Header() {
  return (
    <header className="fixed inset-x-0 top-0 z-40 border-b border-hairline bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <a
          href="#top"
          onClick={scrollTo("#top")}
          data-testid="header-brand"
          className="flex items-center gap-3"
        >
          <span className="relative flex h-11 w-11 items-center justify-center bg-ink">
            <span className="pointer-events-none absolute inset-[3px] border border-white/25" />
            <span className="font-serif text-[15px] tracking-[0.08em] text-ivory">CHK</span>
          </span>
          <span className="leading-tight">
            <span className="block text-[13px] font-semibold uppercase tracking-[0.22em] text-ink">
              Will French
            </span>
            <span className="block text-[10px] uppercase tracking-[0.28em] text-smoke">
              CHK Real Estate
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-9 md:flex">
          <a
            href="#about"
            onClick={scrollTo("#about")}
            data-testid="nav-about-link"
            className="text-[11px] font-semibold uppercase tracking-[0.24em] text-ink/70 transition-colors hover:text-ink"
          >
            About Will
          </a>
          <a
            href="#book"
            onClick={scrollTo("#book")}
            data-testid="nav-book-link"
            className="text-[11px] font-semibold uppercase tracking-[0.24em] text-ink/70 transition-colors hover:text-ink"
          >
            Book a Consultation
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+16475359455"
            data-testid="header-call-btn"
            className="hidden items-center gap-2 border border-ink px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink transition-colors hover:bg-ink hover:text-white sm:flex"
          >
            <Phone size={13} strokeWidth={2.2} />
            (647) 535-9455
          </a>
          <a
            href="#book"
            onClick={scrollTo("#book")}
            data-testid="header-book-btn"
            className="bg-ink px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-ink/80 sm:px-5"
          >
            Book
          </a>
        </div>
      </div>
    </header>
  );
}